import React from 'react';
import styled from 'styled-components';

import ListMagazineLineItem from '@/components/common/communication/magazine/ListMagazineLineItem';
import theme from '@/styles/theme';
import { MagazineLineItemVo } from '@/types/magazine';

interface Props {
  magazine: MagazineLineItemVo;
  isExternal?: boolean;
  isLast?: boolean;
}
const ListMagazineLine = ({ magazine, isExternal = false, isLast = false }: Props) => {
  return (
    <Wrapper>
      <ListMagazineLineItem magazine={magazine} isExternal={isExternal} isLast={isLast} />
    </Wrapper>
  );
};

export default ListMagazineLine;

const Wrapper = styled.li`
  padding: 0 24px;
  &:hover {
    background-color: ${theme.color.gray30};
  }

  &:active {
    background-color: ${theme.color.gray50};
  }
`;
